import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import ErrorBoundary from '@/components/ErrorBoundary';
import '@/App.css';
import Landing from '@/pages/Landing';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import TicketDetail from '@/pages/TicketDetail';
import CAODashboard from '@/pages/CAODashboard';
import ProcessOwnerDashboard from '@/pages/ProcessOwnerDashboard';
import TicketResolverDashboard from '@/pages/TicketResolverDashboard';
import AdminAnalyticsDashboard from '@/pages/AdminAnalyticsDashboard';
import UserManagement from '@/pages/UserManagement';
import FeedbackInterface from '@/pages/FeedbackInterface';
import ProtectedRoute from '@/components/ProtectedRoute';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/tickets/:ticketId" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />
      <Route path="/cao" element={<ProtectedRoute requiredRole="cao"><CAODashboard /></ProtectedRoute>} />
      <Route path="/process-owner" element={<ProtectedRoute requiredRole="process_owner"><ProcessOwnerDashboard /></ProtectedRoute>} />
      <Route path="/resolver" element={<ProtectedRoute><TicketResolverDashboard /></ProtectedRoute>} />
      <Route path="/analytics" element={<ProtectedRoute requiredRole="cao"><AdminAnalyticsDashboard /></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute requiredRole="cao"><UserManagement /></ProtectedRoute>} />
      <Route path="/feedback" element={<ProtectedRoute><FeedbackInterface /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <Router>
          <AppRouter />
        </Router>
        <Toaster position="top-right" richColors />
      </div>
    </ErrorBoundary>
  );
}

export default App;
